import { render, staticRenderFns } from "./security-settings.vue?vue&type=template&id=235877de&scoped=true&"
import script from "./security-settings.vue?vue&type=script&lang=js&"
export * from "./security-settings.vue?vue&type=script&lang=js&"
import style0 from "./security-settings.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./security-settings.vue?vue&type=style&index=1&id=235877de&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "235877de",
  null
  
)

export default component.exports